<template>
      <v-container align="start" justify="start">
        <v-row>
          <v-col>
            <v-card
            class="mb-12"
            color="white lighten-3"
            height="auto"
            min-height="450px"
            >

           <v-container>
                <v-row  align="start" justify="center">
                    <v-col cols="8" >
                      <div >
                        <p class="tituloPagina text-justify">
                            {{ $t(contenidoPaginas[paginaActiva-1].nombre) }}
                        </p>
                        
                        <v-row v-for="(unParrafo, index) in contenidoPaginas[paginaActiva-1].parrafos" :key="index" style="padding: 10px;">
                            <p class="text-justify"  style="font-weight: 900 !important">{{ $t(unParrafo) }}</p>
                        </v-row>
                        </div>
                    </v-col>

                    <v-col cols="auto">
                        <v-img :contain="true" max-height="400px" max-width="200px"
                            :src="require(`@/assets/funcionamiento/${contenidoPaginas[paginaActiva-1].imagen}`)">
                        </v-img>
                     </v-col>
                </v-row>
            </v-container>
            </v-card>

          </v-col>
        </v-row>


        <div class="text-center">
            <v-pagination
            v-model="paginaActiva"
            :length="6"
            ></v-pagination>
        </div>
      </v-container>
</template>

<style scoped>

.tituloPagina{
    font-size: 20px;
    
    color: black;
  }

.fina {
  font-weight: 300 !important;
}

</style>


<script>
export default {
  name: "comoFunciona",

  data: () => ({
    paginaActiva: 1,

    contenidoPaginas: [
      { nombre:'funcionamientoEstancia', 
        imagen: 'datosestancia.png', 
        parrafos: [
            'funcionamientoP1P1',
            'funcionamientoP1P2',
            'funcionamientoP1P3',
            'funcionamientoP1P4'
        ]
      }, 
      { nombre: 'funcionamientoDatosPersonales', 
        imagen: 'datospersonales.png', 
        parrafos: [
            'funcionamientoP2P1',
        ]
      }, 
      { nombre:'funcionamientoDatosFacturacion', 
        imagen: 'datosfacturacion.png', 
        parrafos: [
            'funcionamientoP3P1',
        ]
      }, 
      { nombre:'funcionamientoPago', 
        imagen: 'iframe.png', 
        parrafos: [
            'funcionamientoP4P1',
            'funcionamientoP4P2',
        ]
      }, 
      { nombre: 'funcionamientoReservaRealizada', 
        imagen: 'fin.png', 
        parrafos: [
            'funcionamientoP5P1',
            'funcionamientoP5P2',
            'funcionamientoP5P3'
        ]
      }, 
      { nombre: 'funcionamientoCancelarReserva', 
        imagen: 'cancelar.png', 
        parrafos: [
            'funcionamientoP6P1',
            'funcionamientoP6P2',
            'funcionamientoP6P3'
        ]
      }  
    ], // fin array data.contenidoPaginas


  })
};
</script>
